import type { PortableTextMarkComponent } from '@portabletext/react';
import groq from 'groq';

export const EXTERNAL_LINK_MARK_DEFS_SELECTION = groq`_type == "link" => {
  href,
  openInNew,
}`;

interface Props {
  _type: 'link';
  href: string;
  openInNew?: boolean;
}

const ExternalLink: PortableTextMarkComponent<Props> = ({
  value: { href, openInNew } = {},
  children,
}) => (
  <a
    className="link underline hover:text-leland-primary"
    href={href}
    target={openInNew ? '_blank' : undefined}
    rel="noreferrer"
    id="external_link--go_to_link"
  >
    {children}
  </a>
);

export default ExternalLink;

export const ExternalLinkHtml: PortableTextMarkComponent<Props> = ({
  value: { href, openInNew } = {},
  children,
}) => (
  <a
    href={href}
    target={openInNew ? '_blank' : undefined}
    rel="noreferrer"
    id="external_link--go_to_link"
  >
    {children}
  </a>
);
